<div [formGroup]="formGroup">
  <input type="text" [formControlName]="field.name" />
</div>
